import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../assets/styles/studentattendance.css";

function StudentAttendance() {

  const [attendance, setAttendance] = useState([]);

  const studentId = localStorage.getItem("studentId");

  useEffect(() => {
    axios
      .get(`https://shuttle-craft-student-transport.onrender.com/api/attendance/student/${studentId}`)
      .then((res) => {
        setAttendance(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [studentId]);

  return (
    <div className="attendance-container">
  
      <h2>My Attendance</h2>
  
      <table className="attendance-table">
  
        <thead>
          <tr>
            <th>Date</th>
            <th>Status</th>
          </tr>
        </thead>
  
        <tbody>
          {attendance.map((item, i) => (
  
            <tr key={i}>
  
              <td>
                {new Date(item.date).toLocaleDateString("en-IN", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                })}
              </td>
  
              <td className={item.status === "Present" ? "present" : "absent"}>
                {item.status}
              </td>
  
            </tr>
  
          ))}
        </tbody>
  
      </table>
  
    </div>
  );
}

export default StudentAttendance;